import type { AxiosResponse } from 'axios'
import type ResponseParserChain from '../ResponseParserChain'

import { Leaf7DataStruct } from './types'

export default class Leaf7ResponseParser {
  parse(response: AxiosResponse, chain: ResponseParserChain) {
    // server 端不响应内容
    const contentType = response.headers['content-type']
    if (!contentType) {
      return
    }
    const signature = response.headers['web-encrypt-sign']

    // 若为加密请求，不走contentType是否包含application/json的判断
    if (!signature) {
      // 非 application/json 协议，不处理
      if (contentType.indexOf('application/json') === -1) {
        return chain.doParse(response, chain)
      }
    }

    const { appcode, data, msg }: Leaf7DataStruct = response.data
    if (appcode === '0') {
      return chain.doParse(data, chain)
    } else {
      throw new Error(msg)
    }
  }
}
